var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracksLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.xlkskdfljaldjfljasdfkljlkjsal{\n\t\tfill:none;stroke:currentColor;stroke-width:36;stroke-miterlimit:10;\n\t\tstroke-dasharray: 1000;\n\t\tstroke-dashoffset: 1000;\n\t\tanimation: dash-one 3s linear alternate infinite;\n\t}\n\n\t@keyframes dash-one {\n\t\tfrom {\n\t\t\tstroke-dashoffset: 970;\n\t\t}\n\t\tto {\n\t\t\tstroke-dashoffset: 0;\n\t\t}\n\t}\n\n\t.jaldkalsdjglkajdsgklajsdklgjadslgkjasdlkg{\n\t\tfill:none;stroke:currentColor;stroke-width:32;stroke-miterlimit:10;\n\t\tstroke-dasharray: 1000;\n\t\tstroke-dashoffset: 1000;\n\t\tanimation: dash-three 2s linear alternate infinite;\n\t}\n\n\t@keyframes dash-three {\n\t\tfrom {\n\t\t\tstroke-dashoffset: 970;\n\t\t}\n\t\tto {\n\t\t\tstroke-dashoffset: 0;\n\t\t}\n\t}\n\n\n\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "xlkskdfljaldjfljasdfkljlkjsal",
    d: "M427.6,268.5c-5.2,14-13.7,27.9-25.1,41.2c0,0-0.1,0.1-0.1,0.1L256.7,480.9L111,309.7 c-11.5-13.3-20-27.2-25.2-41.3c-21-55.4-13-118.2,21.3-167.8c34.4-49.8,88.9-78.4,149.6-78.4c60.7,0,115.2,28.6,149.6,78.4 C440.6,150.2,448.6,213,427.6,268.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "jaldkalsdjglkajdsgklajsdklgjadslgkjasdlkg",
    cx: 260,
    cy: 191.5,
    r: 64.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracksLoader);
export default __webpack_public_path__ + "static/media/tracks-loader.9fb9101a38c2db2ba3e6f8d8954c4029.svg";
export { ForwardRef as ReactComponent };